import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/header";
import Landing from "./components/landing";
import CoursePage from "./components/course";
import AboutPage from "./components/about";
import MissionVision from "./components/missionvission";
import Contact from "./components/contact";
import AllCourses from "./components/allCourses";
import AdminLogin from "./components/admin/adminlogin.js";     // ✅ import admin login
import AdminDashboard from "./components/admin/dashboard.js"; // ✅ import admin dashboard

import "./index.css";

function App() {
  return (
    <Router>
      <div className="App overflow-x-hidden">
        <Header />

        <Routes>
          <Route
            path="/"
            element={
              <>
                <Landing />
                <CoursePage />
                <AboutPage />
                <MissionVision />
                <Contact />
              </>
            }
          />
          <Route path="/courses" element={<AllCourses />} />
          
          {/* ✅ Admin Routes */}
          <Route path="/adminlogin" element={<AdminLogin />} />
          <Route path="/dashboard" element={<AdminDashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
